import { factory, am } from './utils';

import httpClient from '@/utils/httpClient';

const GET_MINIONS_TASKS = am(`GET_MINIONS_TASKS`);

export default {
  namespaced: true,
  ...factory({
    state: {
      tasks: { data: [], pages: 0, total: 0 },
      isGetMinionsTasksRequestPending: false,
      isGetMinionsTasksRequestFailed: false
    },
    mutations: {
      [GET_MINIONS_TASKS.STARTED](state) {
        state.isGetMinionsTasksRequestPending = true;
        state.isGetMinionsTasksRequestFailed = false;
      },
      [GET_MINIONS_TASKS.FAILED](state) {
        state.isGetMinionsTasksRequestPending = false;
        state.isGetMinionsTasksRequestFailed = true;
      },
      [GET_MINIONS_TASKS.COMPLETED](state, { tasks, pages, total }) {
        state.tasks = { data: tasks, pages, total };

        state.isGetMinionsTasksRequestPending = false;
      }
    },
    actions: {
      async getMinionsTasks({ commit }, { populate, fields, queryString }) {
        try {
          commit(GET_MINIONS_TASKS.STARTED);

          const queryParams = new URLSearchParams();

          if (populate) {
            for (const pop of populate) {
              queryParams.append('populate', pop);
            }
          }

          if (fields) {
            for (const field of fields) {
              queryParams.append('fields', field);
            }
          }

          const query = queryParams.toString() + (queryString ? `&${queryString}` : '');
          const response = await httpClient.get(`/api/settings/minion-dojo-api/api/tasks?${query}`);
          const { data, meta } = response;

          const paginationData = meta.pagination;
          commit(GET_MINIONS_TASKS.COMPLETED, { tasks: data, pages: paginationData.pagesCount, total: paginationData.total });
        } catch (error) {
          commit(GET_MINIONS_TASKS.FAILED);
          console.error('Error fetching minion tasks:', error);
          throw error;
        }
      }
    }
  })('minionTasks')
};
